import React from "react";

function ConfirmDeleteModal({ item, deleteFunction, onClose }) {
  return (
    // <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4 backdrop-brightness-75 backdrop-blur-sm">
    //   <div
    //     className="relative max-h-fit w-full max-w-xl justify-center overflow-y-scroll rounded-lg bg-white p-4 shadow-lg md:h-auto md:overflow-y-hidden lg:px-6 lg:py-8"
    //     onClick={(e) => e.stopPropagation()}
    //   >
    //     <p>Are you sure you want to delete this {item}?</p>
    //     <div className="absolute bottom-2 right-2 flex">
    //       <button className="text-whire bg-red-500 px-2 py-1 ">Delete</button>
    //       <button className="text-whire bg-red-500 px-2 py-1 ">No</button>
    //     </div>
    //   </div>
    // </div>
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 bg-opacity-50 backdrop-blur-sm">
      <div
        className="w-11/12 rounded-lg bg-white p-6 shadow-lg sm:w-1/3"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-hidden="true"
      >
        {/* Modal Content */}
        <h2 className="mb-4 text-lg font-semibold text-gray-700">
          Are you sure you want to delete this{" "}
          <span className="capitalize tracking-wide text-red-500">{item}</span>
        </h2>
        <p className="mb-6 text-sm text-gray-500">
          This action cannot be undone.
        </p>

        {/* Buttons Section */}
        <div className="flex justify-end gap-4">
          <button
            className="rounded-lg bg-gray-200 px-4 py-2 text-gray-700 transition hover:bg-gray-300"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="rounded-lg bg-red-600 px-4 py-2 text-white transition hover:bg-red-700"
            onClick={deleteFunction}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDeleteModal;
